import React, { Component } from 'react'
import { Button } from '@/components'
import { Input } from '@/components/form'
import cx from 'classnames'
import './FeedbackForm.scss'

export default class FeedbackForm extends Component {
  state = {
    feedback: null,
    feedbackType: null,
    isSubmitted: false,
    isSubmitError: false,
    isSubmitting: false,
  }
  onSubmit = () => {
    const { feedbackType: propFeedbackType, onSubmit } = this.props
    const { feedback, feedbackType } = this.state

    if (onSubmit) {
      const result = onSubmit({
        feedback: feedback,
        feedbackType: feedbackType || propFeedbackType,
      })
      if (result && result.then) {
        this.setState({ isSubmitting: true })
        result
          .then(() => {
            this.setState({
              feedback: null,
              feedbackType: null,
              isSubmitted: true,
              isSubmitError: false,
              isSubmitting: false,
            })
          })
          .catch(() => {
            this.setState({ isSubmitError: true, isSubmitting: false })
          })
        return
      }
    }

    this.setState({ feedback: null, feedbackType: null })
  }

  onChange = (value) => {
    const { onChangeFeedback } = this.props
    this.setState({ feedback: value, isSubmitted: false, isSubmitError: false })
    if (onChangeFeedback) {
      onChangeFeedback(value)
    }
  }

  onSelectFeedbackType = (type) => {
    const { onChangeFeedbackType } = this.props
    this.setState({
      feedbackType: type,
      isSubmitted: false,
      isSubmitError: false,
    })
    if (onChangeFeedbackType) {
      onChangeFeedbackType(type)
    }
  }

  get isSubmitDisabled() {
    const { feedbackType: propFeedbackType } = this.props
    const { feedbackType } = this.state
    return !feedbackType && !propFeedbackType
  }

  render() {
    const {
      additionalFeedbackMessage,
      feedbackType: propFeedbackType,
      hideSubmitButton,
      isMobile,
      successMessage,
    } = this.props

    const { feedback, feedbackType, isSubmitted, isSubmitError, isSubmitting } =
      this.state

    return (
      <div
        className={cx('FeedbackForm', {
          'FeedbackForm--is-mobile': isMobile,
        })}
      >
        <div
          className={cx('FeedbackForm__buttons-wrapper', {
            'FeedbackForm__buttons-wrapper--is-mobile': isMobile,
          })}
        >
          <div className="FeedbackForm__button-wrapper">
            <Button
              className={cx('FeedbackForm__button', {
                'FeedbackForm__button--is-mobile': isMobile,
                'FeedbackForm__button--is-active':
                  (!feedbackType && propFeedbackType === 'negative') ||
                  feedbackType === 'negative',
              })}
              isDanger
              onClick={() => this.onSelectFeedbackType('negative')}
            >
              <i className="FeedbackForm__icon-thumbs-down fa fa-thumbs-down" />
            </Button>
          </div>
          <div className="FeedbackForm__button-wrapper">
            <Button
              className={cx('FeedbackForm__button', {
                'FeedbackForm__button--is-mobile': isMobile,
                'FeedbackForm__button--is-active':
                  (!feedbackType && propFeedbackType === 'positive') ||
                  feedbackType === 'positive',
              })}
              isSuccess
              onClick={() => this.onSelectFeedbackType('positive')}
            >
              <i className="FeedbackForm__icon-thumbs-up fa fa-thumbs-up" />
            </Button>
          </div>
        </div>
        {additionalFeedbackMessage ? (
          <span>{additionalFeedbackMessage}</span>
        ) : null}
        <Input
          isMultiline
          onChange={(event) => this.onChange(event.target.value || '')}
          value={feedback || ''}
        />
        {!hideSubmitButton ? (
          <div className="FeedbackForm__footer">
            <Button
              isDisabled={this.isSubmitDisabled}
              isLoading={isSubmitting}
              onClick={this.onSubmit}
            >
              Submit
            </Button>
          </div>
        ) : null}
        {isSubmitted && successMessage ? (
          <span className="FeedbackForm__status-message FeedbackForm__status-message--success">
            * {successMessage}
          </span>
        ) : null}
        {isSubmitError ? (
          <span className="FeedbackForm__status-message FeedbackForm__status-message--error">
            * Failed to submit feedback
          </span>
        ) : null}
      </div>
    )
  }
}
